import { render, staticRenderFns } from "./ImpostosRetidos.vue?vue&type=template&id=1d9f24f6&"
import script from "./ImpostosRetidos.vue?vue&type=script&lang=js&"
export * from "./ImpostosRetidos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports